"use client";

import TestimonialCard from "./TestimonialCard";
import "./Testimonials.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import kid1 from "../assets/Khawaja_Mujtba_Sahaf.jpeg";
// import kid2 from "../assets/Wahab_Omer.jpeg";
// import kid3 from "../assets/Elina_Kumar.jpeg";
// import kid4 from "../assets/Saadia_Aftab.jpeg";
// import kid5 from "../assets/Eman.jpeg";
// import kid6 from "../assets/MUSTAFA.jpeg";
// import kid7 from "../assets/Abdul_hadi.jpeg";
// import kid8 from "../assets/Minahil_Jahanzeb.jpeg";
// import kid9 from "../assets/Zahra_Umair.jpeg";
// import kid10 from "../assets/Amal.jpeg";
// import kid11 from "../assets/Haris.jpeg";
// import kid12 from "../assets/Carl_Adrianne N.jpg";
// import kid13 from "../assets/Philip.jpeg";
// import kid14 from "../assets/Faith.jpeg";



const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Mujtaba Khawaja Sahaf",
      age: 12,
      image: "Polymath-images/Homepage/kh (1).png",
      testimonial:
        "I enjoyed the learning experience with Polymath-Kids-Abacus. The teacher was very friendly. I highly recommend Polymath-Kids-Abacus.",
      rating: 5,
      country: "Pakistan",
      flag: "PK",
    },
    {
      id: 2,
      name: "Wahaab Omer",
      age: 12,
      image: "Polymath-images/Homepage/kh (2).png",
      testimonial:
        "I feel so proud when my class fellows call me ’BRAINIAC’, because I can effortlessly do mental calculations much faster and accurate than my classmates. Thank you Polymath-Kids.",
      rating: 5,
      country: "Pakistan",
      flag: "PK",
    },
    {
      id: 3,
      name: "Elina Kumari",
      age: 7,
      image: "Polymath-images/Homepage/kh (3).png",
      testimonial:
        "I am very happy now, I am Elina Kumari, 7 years and study in class 2 but I am super fast in math in my class. I earn every week new star in class. I want to thank you Polymath-kids for teaching me ABACUS. I am enjoying it very much.",
      rating: 5,
      country: "Pakistan",
      flag: "PK",
    },
    {
      id: 4,
      name: "Saadia Aftab M/O Khawaja Haroon",
      age: 5,
      image: "Polymath-images/Homepage/kh (4).png",
      testimonial:
        "The mental maths course is a great brain stimulator for kids, and my son enjoys the activities. I especially like the “Do it in your head” exercises, which help track his progress. The teacher encourages kids warmly, building both competition and teamwork skills.",
      rating: 5,
      country: "Pakistan",
      flag: "PK",
    },
    {
      id: 5,
      name: "Eman Omer",
      age: 10,
      image: "Polymath-images/Homepage/kh (5).png",
      testimonial:
        "Abacus is fun to learn and it helps me to calculate big numbers easily. I can do addition and subtraction more quickly.",
      rating: 5,
      country: "Pakistan",
      flag: "PK",
    },
    {
      id: 6,
      name: "MUSTAFA SALEEM BHATTI",
      age: 9,
      image: "Polymath-images/Homepage/kh (6).png",
      testimonial:
        "The abacus program helped in my math classes at school. It made me feel confident in my work. Also it helped me become a more focused student in all my classes. I enjoyed learning from my abacus teacher. She's very nice and encouraging.",
      rating: 5,
      country: "USA",
      flag: "US",
    },
    {
      id: 7,
      name: "Abdul Hadi",
      age: 10,
      image: "Polymath-images/Testimonials/Abdul_hadi.jpeg",
      testimonial:
        "Quite a wonderful Learning experience. Really enjoying the classes with best teacher ever!!",
      rating: 5,
      country: "Pakistan",
      flag: "PK",
    },
    {
      id: 8,
      name: "Minahil Jahanzeb",
      age: 12,
      image: "Polymath-images/Testimonials/Minahil_Jahanzeb.jpeg",
      testimonial:
        "The Adobe Photoshop course was fun and helpful. The content was amazing. It is very good for earning money and doing freelancing.",
      rating: 5,
      country: "Pakistan",
      flag: "PK",
    },
    {
      id: 9,
      name: "Zahra Umair M/O Ayesha Amad",
      age: 15,
      image: "Polymath-images/Testimonials/Zahra_Umair.jpeg",
      testimonial:
        "Ayesha experience had of great summer camp. It was very well planned and executed. Well done to your team. I am impressed beyond expectations.",
      rating: 5,
      country: "Pakistan",
      flag: "PK",
    },
    {
      id: 10,
      name: "Amal Malik",
      age: 15,
      image: "Polymath-images/Testimonials/Amal.jpeg",
      testimonial:
        "Polymath-Kids has sparked my daughter’s interest in technology, and she’s learned web coding quickly. The instructors are knowledgeable and encouraging, keeping her motivated. The supportive admin team makes the experience smooth—I highly recommend it!",
      rating: 5,
      country: "Canada",
      flag: "CA",
    },
    {
      id: 11,
      name: "Haris Malik",
      age: 13,
      image: "Polymath-images/Testimonials/Haris.jpeg",
      testimonial:
        "I’m thrilled with my son’s progress at Polymath-Kids! The mental math program has boosted his speed, confidence, and love for learning. The patient instructors make lessons fun and engaging—he actually looks forward to class!",
      rating: 5,
      country: "Canada",
      flag: "CA",
    },
    {
      id: 12,
      name: "Carl Adrianne Silvio",
      age: 8,
      image: "Polymath-images/Testimonials/Carl_Adrianne N.jpg",
      testimonial:
        "Thank you, Polymath-Kids, for the wonderful experience for my son Carl. A special mention to his teacher, Ms. Aleesha. Thank you, teacher, for everything-my son learned so much from you. You boosted his confidence, especially in speaking. I hope he will continue learning from you, ma'am.",
      rating: 5,
      country: "UAE",
      flag: "AE",
    },
    {
      id: 13,
      name: "Paula Jammarie Santos",
      age: 10,
      image: "Polymath-images/Testimonials/Faith.png",
      testimonial:
        "My daughter had an amazing summer at Polymath-Kids, learning Scratch, Tynker, Canva, and even abacus skills. She loved the classes and eagerly shared her learning each day. A truly worthwhile experience—thank you to the wonderful teachers!",
      rating: 5,
      country: "Canada",
      flag: "CA",
    },
    {
      id: 14,
      name: "Philip",
      age: 8,
      image: "Polymath-images/Testimonials/Philip.png",
      testimonial:
        "The abacus program helped in my math classes at school. It made me feel confident in my work. Also it helped me become a more focused student in all my classes. I enjoyed learning from my abacus teacher. She's very nice and encouraging.",
      rating: 5,
      country: "Canada",
      flag: "CA",
    },
  ];

  // Custom arrow components
  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="custom-arrow prev-arrow" onClick={onClick}>
        <span>‹</span>
      </div>
    );
  };

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="custom-arrow next-arrow" onClick={onClick}>
        <span>›</span>
      </div>
    );
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "25%",
    className: "testimonials__slider",
    customPaging: (i) => <div className="custom-dot"></div>,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: "15%",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: "10%",
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: "0",
          centerMode: false,
        },
      },
    ],
  };

  return (
    <div className="testimonials">
      <h2 className="testimonials-title">
        <span className="what-part">What</span>{" "}
        <span className="learners-part">Our Learners Say</span>
      </h2>
      <div className="testimonials__slider">
        <Slider {...settings}>
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonials__slide">
              <TestimonialCard
                name={testimonial.name}
                age={testimonial.age}
                image={testimonial.image}
                testimonial={testimonial.testimonial}
                rating={testimonial.rating}
                country={testimonial.country}
                flag={testimonial.flag}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Testimonials;
